const AlertType = {
  red: 'red',
  green: 'green',
  blue: 'blue',
}

export default AlertType
